module.exports = __webpack_public_path__ + "static/media/website.d583441d.png";